'use client'
import {createContext} from "react";
import {useContextStrict} from "@web-libs/core/context/context.functions";
import {DictionaryLocale} from "@web-libs/core/internationalization/dictionary.types";

export interface UseTageaRouter {
    push: (path: string) => void;
    getLink: (path: string) => string;
    getFullLink: (path: string) => string;
    getInsitutionId: () => string;
    isCurrentPath: (path: string) => boolean;
    isCurrentPathOrSubPath: (path: string) => boolean;
    changeLanguage: (lang: DictionaryLocale) => void
}

export const TageaRouterContext = createContext<UseTageaRouter|null>(null)
TageaRouterContext.displayName = "TageaRouterContext"

export const useTageaRouter = () => {
    return useContextStrict(TageaRouterContext)
}
